/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import BackpackLogo from 'components/images/BackpackLogo';

import './BackgroundFooter.css';

import Text from 'components/common/Text';
import { PrivacyLink, TermsLink, AcknowledgementsLink } from 'components/pages/other/Policy';

const BackgroundFooterView = (props) => (
  <footer className="cmp-footer">
    <BackpackLogo />
    <div className="cmp-footer-fineprint">
      <ul className="cmp-footer-links font-caption-1 font-color-gsMedLight">
        <li>
          <PrivacyLink />
        </li>
        <li>|</li>
        <li>
          <TermsLink />
        </li>
        <li>|</li>
        <li>
          <AcknowledgementsLink />
        </li>
      </ul>
      <div>
        <Text colorName="gsMedLight" size="caption-1">
          <FormattedMessage id="groups.copyright.message.text" />
        </Text>
      </div>
    </div>
  </footer>
)

export default BackgroundFooterView;
